document.addEventListener("DOMContentLoaded", function() {
  console.log("JavaScript file loaded");

  // Check if the 'collection' query parameter exists and its value
  const urlParams = new URLSearchParams(window.location.search);
  const collection = urlParams.get('collection');

  console.log("Detected Collection:", collection); // Log the detected collection

  // Define collection identifiers
  const menCollections = [
    'men',
    'mens-3d-christmas-hoodies',
    'men-christmas-sweaters',
    'mens-led-christmas-sweaters',
    'mens-christmas-cardigans',
    'christmas-party-suits',
    'solid-color-suits',
    'mens-funny-onesie-pajamas'
  ];

  const womenCollections = [
    'women',
    'ladies-3d-christmas-hoodies',
    'ladies-led-christmas-sweaters',
    'ladies-funny-onesie-pajamas',
    'ladies-christmas-sweaters',
    'ladies-christmas-cardigans'
  ];

  const isMenCollection = menCollections.includes(collection);
  const isWomenCollection = womenCollections.includes(collection);

  console.log("isMenCollection:", isMenCollection);
  console.log("isWomenCollection:", isWomenCollection);

  // Find all media containers with data-type
  const mediaElements = document.querySelectorAll(".product__modal-opener");

  mediaElements.forEach(opener => {
    const mediaType = opener.getAttribute("data-type");
    console.log("Media Type:", mediaType); // Log each media type for debugging

    if (isMenCollection && mediaType !== "Men" && mediaType !== "Unisex") {
      opener.style.display = "none"; // Hide Women images in Men collection
    } else if (isWomenCollection && mediaType !== "Women" && mediaType !== "Unisex") {
      opener.style.display = "none"; // Hide Men images in Women collection
    }
  });
});
